<template>
  <div>
    <el-breadcrumb separator="/" class="breadcrumb">
      <el-breadcrumb-item>{{$t('route.disinfectionManage')}}</el-breadcrumb-item>
      <el-breadcrumb-item>接入设备</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="contentWrapper disinfectList">
      <div class="buttonshebei">
            <el-select
              v-model="value2"
              placeholder="设备编码"
              style="width: 210px; margin: 0 24px"
              @change="setshebisn"
            >
              <el-option
                v-for="itemss in shebeilist"
                :key="itemss"
                :label="itemss"
                :value="itemss"
              />
            </el-select>
            <el-select
              v-model="value1"
              placeholder="厂商"
              style="width: 210px; margin: 0 24px"
               @change="setchangsha"
            >
              <el-option
                v-for="itemas in robotList"
                :key="itemas.id"
                :label="itemas.name"
                :value="itemas.id"      
              />
            </el-select>
        <el-button type="primary" class="shebeibuttonson" @click="newtodisbin"
          >添加设备</el-button
        >
      </div>
        <!-- <div class="title">{{ $t("robot.timedTask") }}</div> -->
        <el-table :data="tableDatatiming" style="width: 100%" class="talbletop">
          <el-table-column :label="'设备名称'">
            <!-- <div>{{scope.row.deviceName}}</div> -->
            <template #default="scope">
              <!-- <div>{{scope.row.deviceName}}</div> -->
              <el-popover effect="light" trigger="hover" width="600" placement="bottom-start">
          <template #default>
            <p>设备型号: {{ scope.row.deviceType }}</p>
            <p>厂商: {{ scope.row.companyName }}</p>
          </template>
          <template #reference>
            <div>
              {{ scope.row.deviceName }}
            </div>
          </template>
        </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="sn" :label="'设备编码'" />
          <el-table-column prop="rfid" :label="'RFID标签'" />
          <el-table-column :label="$t('system.operation')">
            <template #default="scope">
              <el-button
                type="text"
                size="small"
                @click.stop="gowarehouse(scope.$index, scope.row)"
                >进出仓记录</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="godisinfetcrecord(scope.$index, scope.row)"
                >消毒记录</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="setdisbin(scope.$index, scope.row)"
                >编辑</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="removebin(scope.$index, scope.row)"
                >{{ $t("disinfect.shanchu") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="addtimingtask cursorpointers" v-show="tableDatatiming.length <= 20"
            @click="stabilization(addtimingtasks)">
            + {{ $t("disinfect.tjdsrw") }}
          </div> -->
      <el-dialog
        v-model="todisbinfalge"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :modal="false"
        :title="setconfim==='set'?'编辑设备':'添加设备'"
        width="40%"
        center
        :show-close="false"
      >
        <div class="chanshangty">
          <div class="mingzi">设备名称</div>
          <el-input
            v-model.trim="shebeimingcheng"
            class="inputchanshang"
            placeholder="请输入设备名称(必填)"
            size="mini"
          />
        </div>
        <div class="plaeasecsmz">
          {{ pleasecsmzy }}
        </div>
        <div class="chanshangty">
          <div class="mingzi">设备编码</div>
          <el-input
            v-model.trim="shebeibianma"
            class="inputchanshang"
            placeholder="请输入设备编码(必填)"
            size="mini"
          />
        </div>
        <div class="plaeasecsmz">
          {{ pleasecsmdzy }}
        </div>
        <div class="chanshangty">
          <div class="mingzi lengthmingzi">设备型号&厂商</div>
          <el-cascader
          class="inputchanshang"
      v-model="vulue"
      :options="options"
      @change="handleChange"
      size="mini"
    ></el-cascader>
        </div>
        <div class="plaeasecsmz">
          <!-- 请输入设备型号&厂商 -->{{pleasecsidsbxh}}
        </div>
        <div class="chanshangty">
          <div class="mingzi">RFID标签</div>
          <el-input
            v-model.trim="rfidbianqian"
            class="inputchanshang"
            placeholder="请输入RFID标签(选填)"
            size="mini"
          />
        </div>
        <div class="plaeasecsmz">
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="canceltodis">取消</el-button>
            <el-button type="primary" @click="Shutdowntodis">确定</el-button>
          </span>
        </template>
      </el-dialog>
      <el-dialog
        v-model="deletecompanyfalge"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :title="'删除厂商'"
        width="30%"
        center
        :show-close="false"
      >
        <div class="algincenter">将删除设备: {{ deletedetail.sn }}</div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="canceltingflage">{{
              $t("system.cancel")
            }}</el-button>
            <el-button type="primary" @click="detelechangshang(deletedetail)"
              >{{ $t("system.determine") }}
            </el-button>
          </span>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, nextTick, onMounted,ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  deviceLists,
  adddevicess,
  deleteDevices,
  editDevices,
  getForproducers,
  deviceSnlists,
  venderAndDeviceTypeslist
} from "@/apis/group";
import { ElMessage } from "element-plus";
import { stat } from "fs";
export default defineComponent({
  setup() {
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      tableDatatiming: [],
      todisbinfalge: false,
      shebeimingcheng: "",
      shebeibianma: "",
      changshangid:"",
      shebeixinghao: "",
      rfidbianqian: "",
      pleasecsmzy: "",
      pleasecsmdzy: "",
      pleasecsidsbxh:'',
      setconfim: "",
      deletecompanyfalge: false,
      deletedetail: null,
      formInline: {
          companyId: "",
          page: 1,
          pageSize: 100,
          sn: "",
      },
      robotList:[],
      shebeilist:[],
      value1: ref([]),
      value2: ref([]),
      vulue:ref([]),
      options:ref([]),
      defultoption:[],
      weiyiid:null
    });
    const method = reactive({
      fn1(row:any, column:any, cell:any, event:any) {
       console.log(column,row)
      },
      gowarehouse(index: number, row: any) {
        router.push({
          name: "warehouseRecord",
          params: {
            sn: row.sn,
          },
        });
      },
      handleChange(vals:any){
        state.changshangid = vals[0]
        state.shebeixinghao = vals[1]
        console.log(state.vulue)
      },
      setchangsha(val:any) {
         console.log(val)
         state.formInline.companyId = String(val)
         method.getdevlistrs()
      },
       setshebisn(val:any) {
         console.log(val)
         state.formInline.sn = val
         method.getdevlistrs()
      },
      godisinfetcrecord(index: number, row: any) {
        router.push({
          name: "disinfectionRecord",
          params: {
            sn: row.sn,
          },
        });
      },
      setdisbin(index: number, rows: any) {
        state.setconfim = "set";
        console.log(index, rows);
        state.changshangid = rows.companyNameId;
        state.shebeimingcheng = rows.deviceName;
        state.shebeibianma = rows.sn;
        state.shebeixinghao = rows.deviceTypeId;
        state.rfidbianqian = rows.rfid;
        let abc:any = [parseInt(state.changshangid),parseInt(state.shebeixinghao)]
        state.vulue = abc
        state.todisbinfalge = true;
        state.weiyiid = rows.id
        console.log(state.vulue)
      },
      removebin(index: number, rows: any) {
        console.log(index, rows);
        state.deletedetail = rows;
        state.deletecompanyfalge = true;
      },
      canceltingflage() {
        state.deletecompanyfalge = false;
      },
      detelechangshang(elsa: any) {
        deleteDevices({
          sn: elsa.sn,
          deletedBy: 0,
        }).then((resdea: any) => {
          console.log(resdea);
          if (resdea.code === 200) {
            method.getdevlistrs();
            state.deletecompanyfalge = false;
          }
        });
      },
      newtodisbin() {
        state.setconfim = "add";
        state.todisbinfalge = true;
      },
      canceltodis() {
        state.todisbinfalge = false;
        state.options = []
        nextTick(() => {
          state.pleasecsmzy = "";
          state.pleasecsmdzy = "";
          state.pleasecsidsbxh = "";
          state.shebeimingcheng = ''
          state.shebeibianma = "";
          state.changshangid = "";
          state.shebeixinghao = "";
          state.rfidbianqian = "";
          state.vulue = []
          state.options = state.defultoption
          state.weiyiid = null
        });
      },
      getdevlistrs() {
        deviceLists(state.formInline).then((res: any) => {
          console.log(res);
          state.tableDatatiming = res.data.deviceVOList;
        });
      },
      Shutdowntodis() {
        if (state.shebeimingcheng === "") {
          state.pleasecsmzy = "请输入设备名称";
          state.pleasecsmdzy = "";
          state.pleasecsidsbxh = "";
        } else if (state.shebeibianma === "") {
          state.pleasecsmdzy = "请输入设备编码";
          state.pleasecsmzy = "";
          state.pleasecsidsbxh = "";
        } else if (state.changshangid === ""||state.shebeixinghao ==="") {
          state.pleasecsidsbxh = "请输入设备型号&产商";
          state.pleasecsmzy = "";
          state.pleasecsmdzy = "";
        } else {
          if (state.setconfim === "set") {
            console.log("我是设置");
            editDevices({
              companyNameId: state.changshangid,
              deviceName: state.shebeimingcheng,
              deviceTypeId: state.shebeixinghao,
              rfid: state.rfidbianqian,
              sn: state.shebeibianma,
              id: state.weiyiid
            }).then((editres: any) => {
              console.log(editres);
              if (editres.code === 200) {
                ElMessage({
                  message: "编辑设备成功",
                  type: "success",
                });
                method.getdevlistrs();
                state.options = []
                nextTick(() => {
                  state.pleasecsmzy = "";
                  state.pleasecsmdzy = "";
                  state.pleasecsidsbxh = "";
                  state.shebeimingcheng = "";
                  state.shebeibianma = "";
                  state.changshangid = "";
                  state.shebeixinghao = "";
                  state.rfidbianqian = "";
                  state.options = state.defultoption
                  state.vulue = []
                  state.weiyiid = null
                });
                state.todisbinfalge = false;
              } else {
                ElMessage({
                  message: editres.msg,
                });
              }
            });
          } else {
            console.log("我是新增");
            adddevicess({
              companyNameId: state.changshangid,
              deviceName: state.shebeimingcheng,
              deviceTypeId: state.shebeixinghao,
              rfid: state.rfidbianqian,
              sn: state.shebeibianma,
            }).then((ress: any) => {
              console.log(ress);
              if (ress.code === 200) {
                ElMessage({
                  message: "新增设备成功",
                  type: "success",
                });
                method.getdevlistrs();
                state.options = []
                nextTick(() => {
                state.pleasecsmzy = "";
                state.pleasecsmdzy = "";
                state.pleasecsidsbxh = ""; 
                state.shebeimingcheng = "";
                state.shebeibianma = "";
                state.changshangid = "";
                state.shebeixinghao = "";
                state.rfidbianqian = "";
                state.options = state.defultoption
                state.vulue = []
              });
              state.todisbinfalge = false;
              }
            });
          }
        }
      },
    });
    onMounted(() => {
      method.getdevlistrs();
      getForproducers({}).then((ducerreq:any)=>{
        console.log(ducerreq)
        state.robotList = ducerreq.data.companyList
      })
      deviceSnlists({}).then((devisnreqq:any)=>{
        console.log(devisnreqq)
        state.shebeilist = devisnreqq.data
      })
      venderAndDeviceTypeslist({}).then((adndeviereq:any)=>{
        console.log(adndeviereq)
        if (adndeviereq.code === 200) {
          let list = adndeviereq.data
          let arr:any = []
						list.map((item:any, index:number) => {
							let obj = {
								label: item.companyName,
								value: item.companyId,
								children: []
							}
							arr.push(obj)
							let data = item.deviceTypeList
							if (data && data.length > 0) {
								data.map((li:any) => {
									let _obj = {
										label: li.name,
										value: li.id,
									}
									arr[index].children.push(_obj)
								})
							}
						})
						state.options = arr
            state.defultoption = arr
        }
      })
    });
    return {
      ...toRefs(state),
      ...toRefs(method),
    };
  },
});
</script>
<style lang="scss">
.algincenter {
  text-align: center;
}
.disinfectList {
  position: relative;
  min-height: 300px;
  max-height: 100%;
  font-size: 12px;
  .chanshangty {
    font-size: 16px;
    display: flex;
    align-items: center;
  }
  .fontsizes{
    font-size: 12px;
  }
  .mingzi {
    text-align: right;
    margin-right: 2%;
    width: 28%;
  }
  .lengthmingzi{
  }
  .inputchanshang {
    width: 85%;
  }
  .buttonshebei {
    width: 100%;
    height: 40px;
    position: relative;
    margin-left: -20px;
    display: flex;
    .shebeibuttonson {
      position: absolute;
      right: -20px;
      top: 0;
    }
  }
  .talbletop {
    margin-top: 15px;
  }
  .plaeasecsmz {
    height: 30px;
    line-height: 30px;
    color: red;
    padding-left: 20%;
  }
}
</style>